export const loanProductAction = (state = [], action) => {
  switch (action.type) {
    case "LOAN_PRODUCT":
      return action.data;

    default:
      return state;
  }
};
